var _circle, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    stroke: "#222",
    className: "stroke",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "#8E8E8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.005 6.456a.96.96 0 01-.666-.234.794.794 0 01-.252-.594c0-.24.084-.438.252-.594a.939.939 0 01.666-.243c.264 0 .48.081.648.243a.763.763 0 01.26.594.78.78 0 01-.26.594.915.915 0 01-.648.234zm.765.522V12H8.23V6.978h1.54z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleInfo);
export default __webpack_public_path__ + "static/media/bubble-info.08e26c66.svg";
export { ForwardRef as ReactComponent };